declare namespace $ {

	type __shm_hitalama_map_page_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_page['slideshow_enabled'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_page['map'] >['slideshow_enabled'] >[0]
	>
	type __shm_hitalama_map_page_2 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_page['slideshow_frame'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_page['map'] >['slideshow_frame'] >[0]
	>
	type $shm_listener__shm_hitalama_map_page_3 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_map_page['keydown_handler'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $shm_listener__shm_hitalama_map_page_4 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_map_page['keydown_handler_nopassive'] >, ReturnType< $shm_hitalama_map_page['document'] >, ({ 
			'passive': boolean,
		})  ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $shm_listener__shm_hitalama_map_page_5 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_map_page['paste_handler'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $shm_listener__shm_hitalama_map_page_6 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_map_page['history_pointer_end'] >, ReturnType< $shm_hitalama_map_page['document'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $shm_listener__shm_hitalama_map_page_7 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_map_page['history_pointer_end'] >, ReturnType< $shm_hitalama_map_page['window'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type $shm_listener__shm_hitalama_map_page_8 = $mol_type_enforce<
		[ string, ReturnType< $shm_hitalama_map_page['resize_handler'] >, ReturnType< $shm_hitalama_map_page['window'] > ]
		,
		ConstructorParameters< typeof $shm_listener >
	>
	type __shm_hitalama_map_page_9 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_page['box_in_viewport'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_page['Pane'] >['box_in_viewport'] >[0]
	>
	type __shm_hitalama_map_page_10 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_page['select_start'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_page['Pane'] >['select_start'] >[0]
	>
	type __shm_hitalama_map_page_11 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_page['zoom'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_page['Pane'] >['zoom'] >[0]
	>
	type __shm_hitalama_map_page_12 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_page['shift'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_page['Pane'] >['shift'] >[0]
	>
	type __shm_hitalama_map_page_13 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_page['to_real_pos'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_page['Pane'] >['to_real_pos'] >[0]
	>
	type __shm_hitalama_map_page_14 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_page['client_pos_to_pane_pos'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_page['Pane'] >['client_pos_to_pane_pos'] >[0]
	>
	type $shm_hitalama_contextmenu__body_shm_hitalama_map_page_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['contextmenu_body'] >
		,
		ReturnType< $shm_hitalama_contextmenu['body'] >
	>
	type $shm_hitalama_contextmenu__pos_shm_hitalama_map_page_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['contextmenu_pos_shifted'] >
		,
		ReturnType< $shm_hitalama_contextmenu['pos'] >
	>
	type $shm_hitalama_contextmenu__showed_shm_hitalama_map_page_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['contextmenu_showed'] >
		,
		ReturnType< $shm_hitalama_contextmenu['showed'] >
	>
	type $shm_hitalama_map_statistics__map_shm_hitalama_map_page_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['map'] >
		,
		ReturnType< $shm_hitalama_map_statistics['map'] >
	>
	type $shm_hitalama_map_statistics__widgets_shm_hitalama_map_page_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['widgets_source'] >
		,
		ReturnType< $shm_hitalama_map_statistics['widgets'] >
	>
	type $shm_hitalama_map_widget_any__Map_page_shm_hitalama_map_page_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_any['Map_page'] >
	>
	type $shm_hitalama_map_widget_any__widget_shm_hitalama_map_page_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['widget_by_link'] >
		,
		ReturnType< $shm_hitalama_map_widget_any['widget'] >
	>
	type $shm_hitalama_map_selectbox__Map_page_shm_hitalama_map_page_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_selectbox['Map_page'] >
	>
	type $shm_hitalama_map_selectbox__selected_links_shm_hitalama_map_page_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['selected_links'] >
		,
		ReturnType< $shm_hitalama_map_selectbox['selected_links'] >
	>
	type $shm_hitalama_map_selectbox__zoom_shm_hitalama_map_page_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['zoom'] >
		,
		ReturnType< $shm_hitalama_map_selectbox['zoom'] >
	>
	type $shm_hitalama_map_presence_cursor__pos_shm_hitalama_map_page_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['presence_pos'] >
		,
		ReturnType< $shm_hitalama_map_presence_cursor['pos'] >
	>
	type $shm_hitalama_map_page_dragger__Map_page_shm_hitalama_map_page_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_page_dragger['Map_page'] >
	>
	type $shm_hitalama_map_page_keyboard_move__Map_page_shm_hitalama_map_page_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_page_keyboard_move['Map_page'] >
	>
	type $shm_hitalama_map_page_contextmenu__Map_page_shm_hitalama_map_page_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['Map_page'] >
	>
	type $shm_hitalama_map_page_contextmenu__map_shm_hitalama_map_page_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['map'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['map'] >
	>
	type $shm_hitalama_map_page_contextmenu__contextmenu_real_pos_shm_hitalama_map_page_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['contextmenu_real_pos'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['contextmenu_real_pos'] >
	>
	type $shm_hitalama_map_page_contextmenu__contextmenu_showed_shm_hitalama_map_page_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['contextmenu_showed'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['contextmenu_showed'] >
	>
	type $shm_hitalama_map_page_arrows__Map_page_shm_hitalama_map_page_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_page_arrows['Map_page'] >
	>
	type $shm_hitalama_map_page_arrows__visible_shm_hitalama_map_page_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['arrows_visible'] >
		,
		ReturnType< $shm_hitalama_map_page_arrows['visible'] >
	>
	type $shm_hitalama_map_pane__event_shm_hitalama_map_page_34 = $mol_type_enforce<
		({ 
			focusin( next?: ReturnType< $shm_hitalama_map_page['history_edit_start'] > ): ReturnType< $shm_hitalama_map_page['history_edit_start'] >,
			focusout( next?: ReturnType< $shm_hitalama_map_page['history_edit_end'] > ): ReturnType< $shm_hitalama_map_page['history_edit_end'] >,
		})  & ReturnType< $shm_hitalama_map_pane['event'] >
		,
		ReturnType< $shm_hitalama_map_pane['event'] >
	>
	type $shm_hitalama_map_pane__Map_page_shm_hitalama_map_page_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_pane['Map_page'] >
	>
	type $shm_hitalama_map_pane__event_drop_shm_hitalama_map_page_36 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['event_drop'] >
		,
		ReturnType< $shm_hitalama_map_pane['event_drop'] >
	>
	type $shm_hitalama_map_pane__select_resize_shm_hitalama_map_page_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['select_resize'] >
		,
		ReturnType< $shm_hitalama_map_pane['select_resize'] >
	>
	type $shm_hitalama_map_pane__back_event_pointerdown_shm_hitalama_map_page_38 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['back_event_pointerdown'] >
		,
		ReturnType< $shm_hitalama_map_pane['back_event_pointerdown'] >
	>
	type $shm_hitalama_map_pane__back_event_contextmenu_shm_hitalama_map_page_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['back_event_contextmenu'] >
		,
		ReturnType< $shm_hitalama_map_pane['back_event_contextmenu'] >
	>
	type $shm_hitalama_map_pane__prevent_shift_x_shm_hitalama_map_page_40 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['prevent_shift_x'] >
		,
		ReturnType< $shm_hitalama_map_pane['prevent_shift_x'] >
	>
	type $shm_hitalama_map_pane__prevent_shift_y_shm_hitalama_map_page_41 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['prevent_shift_y'] >
		,
		ReturnType< $shm_hitalama_map_pane['prevent_shift_y'] >
	>
	type $shm_hitalama_map_pane__touch_event_disabled_shm_hitalama_map_page_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['touch_event_disabled'] >
		,
		ReturnType< $shm_hitalama_map_pane['touch_event_disabled'] >
	>
	type $shm_hitalama_map_pane__tool_mode_shm_hitalama_map_page_43 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page['interaction_tool_mode'] >
		,
		ReturnType< $shm_hitalama_map_pane['tool_mode'] >
	>
	type $shm_hitalama_map_pane__outside_shm_hitalama_map_page_44 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_pane['outside'] >
	>
	type $shm_hitalama_map_pane__body_shm_hitalama_map_page_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_pane['body'] >
	>
	export class $shm_hitalama_map_page extends $shm_hitalama_entity_page {
		slideshow_enabled( next?: ReturnType< ReturnType< $shm_hitalama_map_page['map'] >['slideshow_enabled'] > ): ReturnType< ReturnType< $shm_hitalama_map_page['map'] >['slideshow_enabled'] >
		camera_locked( ): ReturnType< ReturnType< $shm_hitalama_map_page['map'] >['camera_locked'] >
		interaction_locked( ): ReturnType< ReturnType< $shm_hitalama_map_page['map'] >['interaction_locked'] >
		backup_time( ): ReturnType< ReturnType< $shm_hitalama_map_page['map'] >['backup_time'] >
		slideshow_frame( next?: ReturnType< ReturnType< $shm_hitalama_map_page['map'] >['slideshow_frame'] > ): ReturnType< ReturnType< $shm_hitalama_map_page['map'] >['slideshow_frame'] >
		slideshow_frame_str( ): ReturnType< ReturnType< $shm_hitalama_map_page['map'] >['slideshow_frame_str'] >
		viewport_frames_visible( ): ReturnType< ReturnType< $shm_hitalama_map_page['map'] >['viewport_frames_visible'] >
		selection_cleanup( ): any
		interaction_lock_auto( ): any
		keydown_handler( ): any
		keydown_listener( ): $shm_listener
		keydown_handler_nopassive( ): any
		document( ): any
		keydown_listener_nopassive( ): $shm_listener
		paste_handler( ): any
		paste_listener( ): $shm_listener
		history_pointer_end( ): any
		history_pointercancel_listener( ): $shm_listener
		window( ): any
		history_blur_listener( ): $shm_listener
		resize_handler( ): any
		resize_listener( ): $shm_listener
		pull_drags_synced( ): any
		hovered_link( next?: any ): any
		viewport_to_frame( next?: any ): any
		autobackup( next?: any ): any
		Dragger_set_pos( ): any
		journal_benchmark_auto( ): any
		keyboard_move_auto( ): ReturnType< ReturnType< $shm_hitalama_map_page['Keyboard_move'] >['auto'] >
		Map_page( ): $shm_hitalama_map_page
		contextmenu_showed( next?: boolean ): boolean
		widget_arrows( ): ReturnType< ReturnType< $shm_hitalama_map_page['Arrows'] >['widget_arrows'] >
		history_edit_start( next?: any ): any
		history_edit_end( next?: any ): any
		box_in_viewport( next?: ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['box_in_viewport'] > ): ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['box_in_viewport'] >
		event_drop( next?: any ): any
		select_start( next?: ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['select_start'] > ): ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['select_start'] >
		select_rect_pos( ): ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['select_rect_pos'] >
		select_rect_size( ): ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['select_rect_size'] >
		select_resize( ): any
		zoom( next?: ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['zoom'] > ): ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['zoom'] >
		shift( next?: ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['shift'] > ): ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['shift'] >
		pointer_pos( ): ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['pointer_pos'] >
		real_pointer_pos( ): ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['real_pointer_pos'] >
		to_real_pos( id: any): ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['to_real_pos'] >
		client_pos_to_pane_pos( id: any): ReturnType< ReturnType< $shm_hitalama_map_page['Pane'] >['client_pos_to_pane_pos'] >
		back_event_pointerdown( next?: any ): any
		back_event_contextmenu( next?: any ): any
		prevent_shift_x( ): boolean
		prevent_shift_y( ): boolean
		touch_event_disabled( ): boolean
		interaction_tool_mode( ): string
		contextmenu_pos_shifted( next?: readonly(any)[] ): readonly(any)[]
		Context_menu( ): $shm_hitalama_contextmenu
		contextmenu_visible( ): readonly(any)[]
		Statistics( ): $shm_hitalama_map_statistics
		widget_by_link( id: any): $shm_hitalama_map_widget
		Widget( id: any): $shm_hitalama_map_widget_any
		widgets_view( ): readonly(any)[]
		notebook2_adds( ): readonly(any)[]
		Selectbox( ): $shm_hitalama_map_selectbox
		selectbox_view( ): readonly(any)[]
		presence_pos( id: any): any
		Cursor( id: any): $shm_hitalama_map_presence_cursor
		cursors( ): readonly(any)[]
		Dragger( ): $shm_hitalama_map_page_dragger
		dragger( ): readonly(any)[]
		event_pointerdown( next?: any ): any
		event_resize( next?: any ): any
		widget_float_resizer_size_css( ): string
		widget_props_tab( next?: string ): string
		widget_props_open( id: any, next?: any ): any
		Widget_props( ): $shm_hitalama_map_widget_page
		map( ): $shm_hitalama_map
		cut_title( ): string
		overlayed( ): boolean
		auto( ): readonly(any)[]
		selected_links( next?: readonly($giper_baza_link)[] ): readonly($giper_baza_link)[]
		selected_links_raw( next?: readonly($giper_baza_link)[] ): readonly($giper_baza_link)[]
		selectbox_dragged( next?: boolean ): boolean
		go_to_frame_by_num( id: any): any
		go_to_widget( id: any): any
		set_frame( id: any): any
		some_transforming( ): boolean
		widgets_filtered( ): readonly($shm_hitalama_map_widget)[]
		layout_drop_candidates( ): readonly(any)[]
		layout_drop_best( ): any
		layout_drag_preview( ): any
		layout_drag_commit( ): any
		sub( ): readonly(any)[]
		widgets_source( ): readonly($shm_hitalama_map_widget)[]
		history_showed( next?: boolean ): boolean
		widget_to_top( id: any): any
		widget_to_bottom( id: any): any
		widget_z( id: any, next?: number ): number
		widget_headers_visible( ): boolean
		stickable( ): boolean
		selected( id: any, next?: boolean ): boolean
		hovered( id: any, next?: boolean ): boolean
		hover_styled( id: any): boolean
		sticks_x( id: any): readonly(number)[]
		sticks_y( id: any): readonly(number)[]
		drags_synced( id: any): readonly($rise_drag)[]
		widget_event_contextmenu( id: any, next?: any ): any
		contextmenu_body( next?: readonly(any)[] ): readonly(any)[]
		get_pointer_pos( ): readonly(any)[]
		get_center_pos( ): readonly(any)[]
		contextmenu_pos( next?: readonly(any)[] ): readonly(any)[]
		contextmenu_real_pos( ): readonly(any)[]
		arrows_visible( ): boolean
		tool_mode( next?: string ): string
		widget_tools_hidden( ): boolean
		multi_select_enabled( next?: boolean ): boolean
		Keyboard_move( ): $shm_hitalama_map_page_keyboard_move
		Back_contextmenu_body( ): $shm_hitalama_map_page_contextmenu
		Arrows( ): $shm_hitalama_map_page_arrows
		deselect_all( ): any
		Pane( ): $shm_hitalama_map_pane
		event( ): ({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_page['event_pointerdown'] > ): ReturnType< $shm_hitalama_map_page['event_pointerdown'] >,
			resize( next?: ReturnType< $shm_hitalama_map_page['event_resize'] > ): ReturnType< $shm_hitalama_map_page['event_resize'] >,
		}) 
		style( ): ({ 
			'--shm_hitalama_map_widget_float_resizer_size': ReturnType< $shm_hitalama_map_page['widget_float_resizer_size_css'] >,
		})  & ReturnType< $shm_hitalama_entity_page['style'] >
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map